import {
    ACTIVE_CONSUMER_ORDER_RECEIVE,
    ACTIVE_CONSUMER_ORDER_ERROR,
    ACTIVE_CONSUMER_ORDER_CHANGE_MODE,
    ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE,
    ACTIVE_CONSUMER_ORDER_SET_ORDER,
    ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER
} from '../ConstantsBrafab/constants';
import {
    ViewMode
} from '../constants';

import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    order: {},
    totalCount: 0,
    errors: {},
};

export const activeConsumerOrder = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACTIVE_CONSUMER_ORDER_RECEIVE:
        case ACTIVE_CONSUMER_ORDER_CHANGE_MODE:
        case ACTIVE_CONSUMER_ORDER_CHANGE_CURRENTPAGE:
        case ACTIVE_CONSUMER_ORDER_SET_ORDER:
        case ACTIVE_CONSUMER_ORDER_RECEIVE_ORDER:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case ACTIVE_CONSUMER_ORDER_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
